import { api } from "../../axios";
import { PropertyAPI } from "../../axios";
import axios from "axios";

export const actions = {

    // Employee
    GetOffice(context, data){
        return api.get(`ExternalEmployee/External/Office/${data}`);
    },
    GetEmployee(context, data){
        return api.get(`ExternalEmployee/ExternalOffice/${data.officeId}/${data.campusId}`);
    },
    GetByEmployeeId(context, data){
        return PropertyAPI.get(`AccountableOfficer/${data}`);
    },
    GetEmployeeByDu(context, data){
        return api.get(`ExternalEmployee/DeliveryUnit/${data}`);
    },
    GetBySearch(context, data){
        return PropertyAPI.post(`AccountableOfficer/Search`, data);
    },
    getOfficesByCampus(context, campusId){
        return axios.get(`/api/ExternalEmployee/External/Office/${campusId}`)
    },
    getEmployeeByOfficeandCampus(context, { officeId,  campusId}){
        return axios.get(`/api/ExternalEmployee/ExternalOffice/${officeId}/${campusId}`);
    },
    addExternalEmployee(context, { employeeIdNumber }){
        return axios.post(`/api/ExternalEmployee/Add`, { idNumber: employeeIdNumber })
    },
    updateExternalEmployee(context, { EmployeeIdNumber}){
        return axios.put(`/api/ExternalEmployee/Update`, { idNumber: EmployeeIdNumber })
    },
    deleteExternalEmployee(context, id){
        return axios.delete(`/api/ExternalEmployee/${id}`)
    }
}